var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page"}},[(_vm.loadingPercent < 100)?_c('div',{staticClass:"loading--progress--bar"},[_c('div',{staticClass:"loading--bar--inner",style:({ width: _vm.loaded })})]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }